import React, { useEffect, useState, useCallback } from "react";
import { Box, Checkbox, FormControl, FormControlLabel, FormGroup, Grid, InputLabel, ListItemText, MenuItem, OutlinedInput, Select } from "@mui/material";
import "./ProductDetails.css";
import { images } from "../../config/images";
import { Link } from "react-router";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import Slider from "react-slick";
import PipesChart from "../../components/Chart/PipesChart";
import ProductMap from "./ProductMap";
import { Button } from "../../components/Button/button";
import ProductOverProduct from "../../components/Chart/ProductOverProduct/ProductOverProduct";
import PeriodOverPeriod from "../../components/Chart/PeriodOverPeriod/PeriodOverPeriod";
import PieLineChart from "../../components/Chart/PieLineChart/PieBarChart";
import LocationChart from "../../components/Chart/LocationChart";
import AreaChart from "../../components/Chart/AreaChart";
import { getDailyScanPatternsCounts, getDashboardInsights, getLocationList, getNearbyDistributors, getNearByMapCounts, getProduct, getProductLocationBasedSizeCounts, getProductOverProductBarGraph, getProductScanByUserRoleCounts, getProductSizeCounts, getProductSizePercentageCounts, getScannedPipesCount, getSize, getTop5CrossORCounterGraphCount, getUserRoleList } from "../Pipes/services";

const ProductDetails = () => {
    const [productIds, setProductIds] = useState([]); // Store selected product IDs
    const [sizeIds, setSizeIds] = useState([]); // Store selected size IDs
    const [productData, setProductData] = useState([]); // Store fetch product data for filter
    const [sizeData, setSizeData] = useState([]); // Store fetch size data for filter
    const [locationData, setLocationData] = useState(null); // Store fetch location data for filter
    const [locationIds, setLocationIds] = useState([]); // Store selected location IDs
    const [userRoleList, setUserRoleList] = useState([]); // Store fetch user role list for filter
    const [selectRoleId, setRoleId] = useState([]); // Store selected user role IDs
    const [dateRange, setDateRange] = useState({ startDate: '', endDate: '' }); // Store date range for filter
    const [pipesData, setPipesData] = useState([]); // Store fetch pipes data for Pipes stats chart
    const [pipesStats, setPipeStats] = useState([]); // Pipes stats chart data for representation
    const [productSizeData, setProductSizeData] = useState([]); // Store fetch product size data for product chart
    const [productSizePercentageData, setProductSizePercentageData] = useState([]); // Store fetch product size percentage data for product percentage chart (counterfeit and cross selling)
    const [locationStatusChoice, setLocationStatusChoice] = useState('Counterfeit'); // Location status choice selection state
    const [locationDataStatusChoice, setLocationDataStatusChoice] = useState('Counterfeit'); // Status choice for which current location/map data was fetched (updates only when data arrives)
    const [locationChartData, setLocationChartData] = useState([]); // Store fetch location chart data for location chart
    const [scanByUserRoleData, setScanByUserRoleData] = useState([]); // Store fetch scan by user role data for scan by user role chart
    const [top5CrossSellingGraphData, setTop5CrossSellingGraphData] = useState([]); // Store fetch top 5 cross selling graph data for top 5 cross selling graph
    const [top5CounterfeitGraphData, setTop5CounterfeitGraphData] = useState([]); // Store fetch top 5 counterfeit graph data for top 5 counterfeit graph
    const [dailyScanPatternsData, setDailyScanPatternsData] = useState([]); // Store fetch daily scan patterns data for daily scan patterns chart
    const [nearByDistributorList, setNearByDistributorList] = useState([]); // Store fetch near by distributor list for near by distributor list
    const [mapLocationData, setMapLocationData] = useState([]); // Store fetch map location data for map
    const [nearByCitySelected, setNearByCitySelected] = useState([]); // Store fetch near by city selected for near by distributor list
    const [nearByStateSelected, setNearByStateSelected] = useState([]); // Store fetch near by state selected for near by distributor list
    const [maxStateCount, setMaxStateCount] = useState([]); // Store fetch max state count for near by distributor list
    const [insightsData, setInsightsData] = useState([]); // Store fetch insights data for insights chart
    const [isFilterOpen, setIsFilterOpen] = useState(false); // Filter open state
    const [filters, setFilters] = useState({ android: true, ios: true, }); // Device type filter state
    const [activeChartFilter, setActiveChartFilter] = useState(null); // Tracks which chart filter popup is open ('product' | 'period' | null)

    // On change of the product in filter set selected product in state 
    const handleChange = (event) => {
        const { target: { value }, } = event;

        const selectedItems = productData.filter((item) =>
            value.includes(item.product_name)
        );

        setProductIds(
            selectedItems.map((item) => ({
                id: item.id,
                product_name: item.product_name,
            }))
        );

    };
    // On change of the location in filter set selected location in state
    const handlelocationChange = (event) => {
        const { target: { value }, } = event;

        const selectedLocations = locationData.filter((item) =>
            value.includes(item.location)
        );

        setLocationIds(selectedLocations.map((item) => ({
            id: item.id,
            location: item.location,
        })));

    };
    // On change of the size in filter set selected size in state
    const handleChangeSize = (event) => {
        const { target: { value }, } = event;

        const selectedItems = sizeData.filter((item) => value.includes(item.size));

        setSizeIds(
            selectedItems.map((item) => ({
                id: item.id,
                size: item.size,
            }))
        );
    };
    // Insights slider settings 
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 2,
        nextArrow: <img src={images.rightArrowIcon} alt="next" />,
        prevArrow: <img src={images.leftArrowIcon} alt="previous" />,
    };
    // Fetch data for product stats chart
    useEffect(() => {
        const defaultStats = [
            {
                value: 0,
                label: "Total Scanned",
                percentage: "0.00",
                trend: "up",
                background: images.blackPipeBackgound,
                color: "green",
            },
            {
                value: 0,
                label: "Counterfeit",
                percentage: "0.00",
                trend: "up",
                background: images.redPipeBackground,
                color: "red",
            },
            {
                value: 0,
                label: "Cross Selling",
                percentage: "0.00",
                trend: "up",
                background: images.yellowPipeBackground,
                color: "yellow",
            },
            {
                value: 0,
                label: "Genuine",
                percentage: "0.00",
                trend: "up",
                background: images.greenPipeBackground,
                color: "green",
            },
        ];
        if (pipesData && Object.keys(pipesData).length > 0) {
            const stats = [
                {
                    value: pipesData.total_count?.total_count || 0,
                    label: "Total Scanned",
                    percentage: Number(pipesData.total_count?.percentage || 0).toFixed(2),
                    trend: pipesData.total_count?.increase ? "up" : "down",
                    background: images.blackPipeBackgound,
                    color: "black",
                },
                {
                    value: pipesData.failed_count?.counterfeit_count || 0,
                    label: "Counterfeit",
                    percentage: Number(pipesData.failed_count?.percentage || 0).toFixed(2),
                    trend: pipesData.failed_count?.increase ? "up" : "down",
                    background: images.redPipeBackground,
                    color: "red",
                },
                {
                    value: pipesData.cross_selling_count?.cross_selling_count || 0,
                    label: "Cross Selling",
                    percentage: Number(pipesData.cross_selling_count?.percentage || 0).toFixed(2),
                    trend: pipesData.cross_selling_count?.increase ? "up" : "down",
                    background: images.yellowPipeBackground,
                    color: "yellow",
                },
                {
                    value: pipesData.passed_count?.genuine_count || 0,
                    label: "Genuine",
                    percentage: Number(pipesData.passed_count?.percentage || 0).toFixed(2),
                    trend: pipesData.passed_count?.increase ? "up" : "down",
                    background: images.greenPipeBackground,
                    color: "green",
                },
            ];
            setPipeStats(stats);
        } else {
            setPipeStats(defaultStats);
        }
    }, [pipesData]);
    // filter submit fetch api response based on filtered data
    const handleFilterClose = () => {
        setIsFilterOpen(false);
        fetchData(getScannedPipesCount, setPipesData); // fetch data for product stats after filter submit
        fetchData(getProductSizeCounts, setProductSizeData) // fetch data for product size scan after filter submit
        fetchData(getProductSizePercentageCounts, setProductSizePercentageData) // fetch data for product size percentage after filter submit
        fetchData(getProductLocationBasedSizeCounts, setLocationChartData) // fetch data for location based on status choice selection after filter submit
        fetchData(getProductScanByUserRoleCounts, setScanByUserRoleData) // fetch data for scan by user role after filter submit
        fetchData(getTop5CrossORCounterGraphCount, setTop5CrossSellingGraphData) // fetch data for top 5 cross selling after filter submit
        fetchData(getTop5CrossORCounterGraphCount, setTop5CounterfeitGraphData) // fetch data for top 5 counterfeit after filter submit
        fetchData(getDailyScanPatternsCounts, setDailyScanPatternsData) // fetch data for daily scan patterns after filter submit
    };
    // set device type filter state when filter change
    const handleFilterChange = (name) => (event) => {
        setFilters({ ...filters, [name]: event.target.checked });
    };
    // Fetch data for filter when component mount
    useEffect(() => {
        fetchAllData();
    }, []);
    // On change of the user role in filter set selected user in state
    const handleFilterRoleChange = (roleId) => (event) => {
        if (event.target.checked) {
            const selectedRole = userRoleList.find(role => role.id === roleId);
            setRoleId([...selectRoleId, {
                id: selectedRole.id,
                name: selectedRole.name
            }]);
        } else {
            setRoleId(selectRoleId.filter(role => role.id !== roleId));
        }
    };
    // Api call for fetch data for filter and set default filter values 
    const fetchAllData = async () => {
        const isSuccess = (res) => res?.status === 200 || res?.status === 201;
        try {
            const [productRes, sizeRes, locationRes, roleRes] = await Promise.all([
                getProduct(),
                getSize(),
                getLocationList(),
                getUserRoleList(),
            ]);

            if (isSuccess(productRes)) {
                setProductData(productRes.data.payload);
                // By default set first product checked
                setProductIds([productRes.data.payload[0]]);
            } else {
                setProductData([]);
            }

            if (isSuccess(sizeRes)) {
                setSizeData(sizeRes.data.payload);
                // By default set all size checked
                setSizeIds(sizeRes.data.payload.map(item => ({
                    id: item.id,
                    size: item.size
                })));
            } else {
                setSizeData([]);
            }

            if (isSuccess(locationRes)) {
                setLocationData(locationRes.data.payload);
                // By default set all location checked
                setLocationIds(locationRes.data.payload.map(item => ({
                    id: item.id,
                    location: item.location
                })));
            } else {
                setLocationData([]);
            }

            if (isSuccess(roleRes)) {
                setUserRoleList(roleRes.data.payload);
                //By default set all role checked
                setRoleId(roleRes.data.payload);
            }
        } catch (error) {
            setProductData([]);
            setSizeData([]);
            setLocationData([]);
            setUserRoleList([]);
        }
    };
    // Format date for api call
    const formatDate = (date, isEndDate = false) => {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        const time = isEndDate ? '23:59:59' : '00:00:00';
        return `${year}-${month}-${day} ${time}`;
    };
    // Default set last one month date for start and end date 
    useEffect(() => {
        const end = new Date();
        const start = new Date();
        start.setMonth(end.getMonth() - 1);

        setDateRange({ startDate: formatDate(start, false), endDate: formatDate(end, true) });
    }, []);
    // On change of the time filter set start and end date in state
    const handleTimeFilterChange = (event) => {
        const months = parseInt(event.target.value);
        const end = new Date();
        const start = new Date();
        start.setMonth(end.getMonth() - months);

        setDateRange({ startDate: formatDate(start, false), endDate: formatDate(end, true) });
    };
    // Params for api call
    const buildParams = (apiCall, setDataCallback) => {
        const params = {
            product_id: productIds.map((item) => item.id),
            start_date: dateRange.startDate,
            end_date: dateRange.endDate,
            location_name: locationIds.map((item) => item.location),
            scan_by: selectRoleId.map((item) => item.id),
            device_types: [
                ...(filters.android ? [0] : []),
                ...(filters.ios ? [1] : [])
            ],
        };

        // Add size parameter for all APIs except getTop5CrossORCounterGraphCount
        if (apiCall !== getTop5CrossORCounterGraphCount) {
            params.size = sizeIds.map((item) => item.id);
        }

        // Add status_choice only for getProductLocationBasedSizeCounts
        if (apiCall === getProductLocationBasedSizeCounts && locationStatusChoice) {
            params.status_choice = locationStatusChoice === "Cross Selling" ? 2 : 3;
        } else if (setDataCallback === setTop5CounterfeitGraphData) {
            // Set status_choice to 3 for Top 5 Counterfeit Product API
            params.status_choice = 3;
        } else if (setDataCallback === setTop5CrossSellingGraphData) {
            // Set status_choice to 2 for Top 5 Cross Selling Product API
            params.status_choice = 2;
        } else if (apiCall === getNearByMapCounts && locationStatusChoice) {
            params.status_choice = locationStatusChoice === "Cross Selling" ? 2 : 3;
        }


        if (apiCall === getNearbyDistributors) {
            const params = {};

            if (nearByCitySelected && nearByCitySelected.length > 0) {
                params.city = nearByCitySelected;
            } else if (nearByStateSelected && nearByStateSelected.length > 0) {
                params.state = nearByStateSelected;
            } else {
                params.state = maxStateCount;
            }
            return params;
        }
        return params;
    };
    // Normalize map API response to LocationMapComponent expected format (state, latitude, longitude, product_count, cities)
    const normalizeMapLocationData = useCallback((payload) => {
        const raw = Array.isArray(payload)
            ? payload
            : (payload && (Array.isArray(payload.data) ? payload.data : payload.payload)) || [];
        const arr = Array.isArray(raw) ? raw : [];
        return arr.map((item) => {
            const lat = item.latitude ?? item.lat;
            const lng = item.longitude ?? item.lng;
            const cities = item.cities && item.cities.length > 0
                ? item.cities.map((c) => ({
                    city: c.city ?? c.location ?? "",
                    latitude: c.latitude ?? c.lat,
                    longitude: c.longitude ?? c.lng,
                    product_count: c.product_count ?? c.count ?? 0,
                })).filter((c) => c.latitude != null && c.longitude != null)
                : (lat != null && lng != null ? [{
                    city: item.city ?? item.location ?? item.state ?? "",
                    latitude: lat,
                    longitude: lng,
                    product_count: item.product_count ?? item.count ?? 0,
                }] : []);
            return {
                state: item.state ?? item.location ?? item.city ?? "",
                latitude: lat,
                longitude: lng,
                product_count: item.product_count ?? item.count ?? 0,
                cities,
            };
        }).filter((s) => s.latitude != null && s.longitude != null);
    }, []);
    // Comman Fetch data for api call
    const fetchData = async (apiCall, setDataCallback) => {
        const params = buildParams(apiCall, setDataCallback);
        try {
            const resp = await apiCall(params);
            if (resp.status === 200 || resp.status === 201) {
                setDataCallback(resp.data.payload);
            }
        } catch (error) {
            if (apiCall === getNearByMapCounts) {
                setMapLocationData([]);
            } else {
                setDataCallback({});
            }
        }
    };
    // When valid start date, end date and product selected fetch api for all charts
    useEffect(() => {
        if (dateRange.startDate && dateRange.endDate && productData.length > 0) {
            // Clear location chart, map, and related data immediately when fetching (filter change, date/product change)
            setLocationChartData([]);
            setMapLocationData([]);
            setMaxStateCount("");
            setNearByDistributorList([]);
            const statusUsed = locationStatusChoice;
            const setLocationChartDataAndStatus = (data) => {
                setLocationChartData(Array.isArray(data) ? data : []);
                setLocationDataStatusChoice(statusUsed);
            };
            const setMapDataAndStatus = (payload) => {
                setMapLocationData(normalizeMapLocationData(payload));
                setLocationDataStatusChoice(statusUsed);
            };
            // startDate, endDate and product id is complusary in params to fetch api 
            fetchData(getScannedPipesCount, setPipesData); // fetch data for product stats on component mount
            fetchData(getProductSizeCounts, setProductSizeData); // fetch data for product size scan on component mount
            fetchData(getProductSizePercentageCounts, setProductSizePercentageData); // fetch data for product size percentage on component mount
            fetchData(getProductLocationBasedSizeCounts, setLocationChartDataAndStatus); // fetch data for location based on status choice selection on component mount 
            fetchData(getProductScanByUserRoleCounts, setScanByUserRoleData); // fetch data for scan by user role on component mount  
            fetchData(getTop5CrossORCounterGraphCount, setTop5CrossSellingGraphData); // fetch data for top 5 cross selling on component mount
            fetchData(getTop5CrossORCounterGraphCount, setTop5CounterfeitGraphData); // fetch data for top 5 counter selling on component mount
            fetchData(getDailyScanPatternsCounts, setDailyScanPatternsData); // fetch data for daily scan patterns on component mount
            fetchData(getNearByMapCounts, setMapDataAndStatus); // fetch data for map location on component mount
            fetchData(getDashboardInsights, setInsightsData); // fetch data for insights on component mount
        }
    }, [dateRange.startDate, dateRange.endDate, productData, locationStatusChoice]);
    // Get max state data for getting near by distributor data 
    const getMaxStateData = useCallback(() => {
        if (!Array.isArray(mapLocationData) || mapLocationData.length === 0) {
            return null;
        }
    
        return mapLocationData.reduce(
            (max, state) => (state.product_count ?? state.count ?? 0) > (max.product_count ?? max.count ?? 0) ? state : max,
            mapLocationData[0]
        );
    }, [mapLocationData]);
    
    // Set which state has max count when map location data is fetched
    useEffect(() => {
        const maxState = getMaxStateData();
        if (maxState) {
            setMaxStateCount(maxState.state || maxState.location || maxState.city || "");
        }
    }, [mapLocationData]);
    // fetch near by distributor data when state of city is clicked and based on max state when component mount
    useEffect(() => {
        if (maxStateCount && maxStateCount.length > 0) {
            fetchData(getNearbyDistributors, setNearByDistributorList);
        } else if ((nearByStateSelected && nearByStateSelected.length > 0) || (nearByCitySelected && nearByCitySelected.length > 0)) {
            fetchData(getNearbyDistributors, setNearByDistributorList);
        }
    }, [maxStateCount, nearByStateSelected, nearByCitySelected]);

    return (
        <Box className="products-details-container">
            <Box className="products-details-header">
                <Link to="/" className="page-back-link">
                    <ArrowBackIcon />
                    <span className="back-text product-details">
                        Digital Vigilance - Products
                    </span>
                </Link>
                <Box className="products-details-header-content">
                    <div className="dropdown-container">
                        <select className="time-filter-dropdown" onChange={handleTimeFilterChange} defaultValue="1">
                            <option value="1">Last 1 Month</option>
                            <option value="3">Last 3 Months</option>
                            <option value="6">Last 6 Months</option>
                            <option value="12">Last 12 Months</option>
                        </select>
                    </div>
                    <div style={{ position: "relative" }}>
                        {isFilterOpen && (
                            <div
                                style={{ position: "fixed", inset: 0, zIndex: 1001 }}
                                onClick={() => setIsFilterOpen(false)}
                            />
                        )}
                        <div className="filter-wrapper">
                            <button
                                className="product-filter-button"
                                onClick={() => setIsFilterOpen(!isFilterOpen)}
                            >
                                <img src={images.filter} alt="" className="filter-icon" />
                            </button>
                            {isFilterOpen && (
                                <div className="filter-dropdown-data">
                                    <Box className="product-filter-title">Filters</Box>
                                    <FormGroup className="filter-popup-checkbox">
                                        <Box className="products-selection">
                                            <FormControl sx={{ marginBottom: 2, width: 300 }}>
                                                <InputLabel>Products</InputLabel>
                                                <Select
                                                    multiple
                                                    value={productIds.map((item) => item.product_name)}
                                                    onChange={handleChange}
                                                    input={<OutlinedInput label="Products" />}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    sx={{ "& .MuiSelect-select": { padding: 1 } }}
                                                    MenuProps={{ PaperProps: { style: { maxHeight: 200 }, ref: (el) => { if (el) el.scrollTop = 0; } } }}
                                                >
                                                    <MenuItem value="all" sx={{ p: 0 }}>
                                                        <Checkbox
                                                            checked={productIds.length === productData.length}
                                                            onChange={() => {
                                                                if (productIds.length === productData.length) {
                                                                    setProductIds([]);
                                                                } else {
                                                                    setProductIds(productData.map(item => ({
                                                                        id: item.id,
                                                                        product_name: item.product_name
                                                                    })));
                                                                }
                                                            }}
                                                        />
                                                        <ListItemText primary="Select All" />
                                                    </MenuItem>
                                                    {productData.map((item) => (
                                                        <MenuItem key={item.id} value={item.product_name} sx={{ p: 0 }} >
                                                            <Checkbox checked={productIds.some(
                                                                (cat) => cat.id === item.id
                                                            )}
                                                            />
                                                            <ListItemText primary={item.product_name} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box className="size-selection">
                                            <FormControl sx={{ marginBottom: 2, width: 300 }}>
                                                <InputLabel >Size</InputLabel>
                                                <Select
                                                    multiple
                                                    value={sizeIds.map((item) => item.size)}
                                                    onChange={handleChangeSize}
                                                    input={<OutlinedInput label="Size" />}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    sx={{ "& .MuiSelect-select": { padding: 1 } }}
                                                    MenuProps={{ PaperProps: { style: { maxHeight: 200 }, ref: (el) => { if (el) el.scrollTop = 0; } } }}
                                                >
                                                    <MenuItem value="all" sx={{ p: 0 }}>
                                                        <Checkbox
                                                            checked={sizeIds.length === sizeData.length}
                                                            onChange={() => {
                                                                if (sizeIds.length === sizeData.length) {
                                                                    setSizeIds([]);
                                                                } else {
                                                                    setSizeIds(sizeData.map(item => ({
                                                                        id: item.id,
                                                                        size: item.size
                                                                    })));
                                                                }
                                                            }}
                                                        />
                                                        <ListItemText primary="Select All" />
                                                    </MenuItem>
                                                    {sizeData.map((item) => (
                                                        <MenuItem key={item.id} value={item.size} sx={{ p: 0 }}  >
                                                            <Checkbox checked={sizeIds.some(
                                                                (cat) => cat.id === item.id
                                                            )}
                                                            />
                                                            <ListItemText primary={item.size} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box className="location-selection">
                                            <FormControl sx={{ marginBottom: 2, width: 300 }}>
                                                <InputLabel>Location</InputLabel>
                                                <Select
                                                    multiple
                                                    value={locationIds.map((item) => item.location)}
                                                    onChange={handlelocationChange}
                                                    input={<OutlinedInput label="Location" />}
                                                    renderValue={(selected) => selected.join(", ")}
                                                    sx={{ "& .MuiSelect-select": { padding: 1 } }}
                                                    MenuProps={{ PaperProps: { style: { maxHeight: 200 }, ref: (el) => { if (el) el.scrollTop = 0; } } }}
                                                >
                                                    <MenuItem value="all" sx={{ p: 0 }}>
                                                        <Checkbox
                                                            checked={locationIds.length === locationData.length}
                                                            onChange={() => {
                                                                if (locationIds.length === locationData.length) {
                                                                    setLocationIds([]);
                                                                } else {
                                                                    setLocationIds(locationData.map(item => ({
                                                                        id: item.id,
                                                                        location: item.location
                                                                    })));
                                                                }
                                                            }}
                                                        />
                                                        <ListItemText primary="Select All" />
                                                    </MenuItem>
                                                    {locationData.map((item) => (
                                                        <MenuItem key={item.id} value={item.location} sx={{ p: 0 }}  >
                                                            <Checkbox checked={locationIds.some(
                                                                (cat) => cat.id === item.id
                                                            )}
                                                            />
                                                            <ListItemText primary={item.location} />
                                                        </MenuItem>
                                                    ))}
                                                </Select>
                                            </FormControl>
                                        </Box>
                                        <Box className="mb-2">
                                            <Box className="product-section-title">Scan By:</Box>
                                            {userRoleList.map((role) => (
                                                <FormControlLabel
                                                    key={role.id}
                                                    control={
                                                        <Checkbox
                                                            checked={selectRoleId.some((selectedRole) => selectedRole.id === role.id)}
                                                            onChange={handleFilterRoleChange(role.id)}
                                                            size="small"
                                                        />
                                                    }
                                                    label={role.name}
                                                />
                                            ))}
                                        </Box>
                                        <Box className="">
                                            <Box className="product-section-title">Device:</Box>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox checked={filters.android} onChange={handleFilterChange("android")} size="small" />
                                                }
                                                label="Android"
                                            />
                                            <FormControlLabel
                                                control={
                                                    <Checkbox checked={filters.ios} onChange={handleFilterChange("ios")} size="small" />
                                                }
                                                label="iOS"
                                            />
                                        </Box>
                                        <Button
                                            onClick={handleFilterClose}
                                            title="Submit"
                                            classname={"custom-button"}
                                        />
                                    </FormGroup>
                                </div>
                            )}
                        </div>
                    </div>
                </Box>
                {/* Insights Slider and stats  */}
                <Box className="product-details-insights">
                    <div className="insights-wrapper">
                        <div className="product-insights-title d-flex gap-1">
                            <div className="header-text text-data">
                                Insights! (<span>powered by</span>{" "}
                                <span className="hai">hai</span><sup> ®</sup>)
                            </div>
                            <img src={images.blubIcon} alt="bulb" className="bulb-icon" />
                        </div>
                        <Box className="product-details-insights-content">
                            <div className="insights-slider-div">
                                <div className="insights-slider">
                                    {insightsData?.length ? (
                                        <Slider {...settings}>
                                            {insightsData.map((insight, index) => (
                                                <div key={index} className="d-flex align-items-center justify-content-between">
                                                    <div className="insight-slide">
                                                        <p>{insight}</p>
                                                    </div>
                                                    {index % 2 === 0 && index < insightsData.length - 1 && (
                                                        <div className="pipe-sign"></div>
                                                    )}
                                                </div>
                                            ))}
                                        </Slider>
                                    ) : (
                                        <div className="no-data-message-insights">No Data Found</div>
                                    )}
                                </div>
                            </div>
                            <Box className="stats-content">
                                {pipesStats.map((stat, index) => (
                                    <div className="stat-item" key={index}>
                                        <div className="shield" style={{ backgroundImage: `url(${stat.background})` }}  >
                                            <div className="tooltip">
                                                {stat.label}
                                            </div>
                                            <div className="shield-inner">
                                                <div className="stat-value">{stat.value}</div>
                                                <div className="stat-label">{stat.label}</div>
                                                <div className={`stat-percentage ${stat.color}`}>
                                                    {stat.trend === "up" ? "▲" : "▼"}{stat.percentage}%
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </Box>
                        </Box>
                    </div>
                </Box>
                {/*  Pipes Charts  and counterfeit and cross selling pie and bar chart */}
                <Box className="product-details-charts">
                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <Box className="chart-container">
                                {productSizeData.length > 0 ? (
                                    <PipesChart
                                        product={productIds.map((item) => item.product_name)} // title name 
                                        data={productSizeData}
                                    />) : (
                                    <div className="no-data-container">
                                        <img
                                            src={images.noDataFoundImg}
                                            className="no-data-img"
                                            alt="No Data Found"
                                        />
                                    </div>
                                )}
                            </Box>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 3 }}>
                            <Box className="chart-container">
                                {/* Counterfeit Chart */}
                                {productSizePercentageData?.counterfeit?.size_counts.length > 0 ? (
                                    <PieLineChart label="Counterfeit"
                                        chartData={productSizePercentageData.counterfeit}
                                        sizeData={sizeData}
                                        userRoleList={userRoleList}
                                    />
                                ) : (
                                    <div className="no-data-container">
                                        <img
                                            src={images.noDataFoundImg}
                                            className="no-data-img"
                                            alt="No Data Found"
                                        />
                                    </div>
                                )}
                            </Box>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 3 }}>
                            <Box className="chart-container">
                                {/* Cross Selling Chart */}
                                {productSizePercentageData?.cross_selling?.size_counts.length > 0 ? (
                                    <PieLineChart label="Cross Selling"
                                        chartData={productSizePercentageData.cross_selling}
                                        sizeData={sizeData}
                                        userRoleList={userRoleList}
                                    />
                                ) : (
                                    <div className="no-data-container">
                                        <img
                                            src={images.noDataFoundImg}
                                            className="no-data-img"
                                            alt="No Data Found"
                                        />
                                    </div>
                                )}
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {/* Location chart and near by distributor chart */}
                <Box className="product-details-charts">
                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12, md: 6 }}>
                            <Box className="chart-container">
                                {/* Locations chart */}
                                <LocationChart data={locationChartData} locationStatusChoice={locationStatusChoice} locationDataStatusChoice={locationDataStatusChoice} setLocationStatusChoice={setLocationStatusChoice} />
                            </Box>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 2 }}>
                            <Box className="chart-container">
                                <div className="nearby-distributor">
                                    <h3 className="nearby-title">Near by Distributor</h3>
                                    <div className="distributor-list">
                                        {nearByDistributorList?.length > 0 ? (
                                            nearByDistributorList.map((item, index) => (
                                                <div className="distributor-item" key={index}>
                                                    {item.distributor}
                                                </div>
                                            ))
                                        ) : (
                                            <div className="distributor-item">No data found</div>
                                        )}
                                    </div>
                                </div>
                            </Box>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 4 }}>
                            <Box className="chart-container map-container-wrapper" id="map-container" >
                                {/* Map   */}
                                <ProductMap mapLocationData={mapLocationData} setNearByStateSelected={setNearByStateSelected}
                                    setNearByCitySelected={setNearByCitySelected} locationStatusChoice={locationDataStatusChoice} />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {/* Scan by and daily scan chart */}
                <Box className="product-details-charts">
                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12, md: 9 }}>
                            <Box className="chart-container">
                                <PieLineChart label="Scan By"
                                    scanByData={scanByUserRoleData}
                                    counterfeitData={top5CounterfeitGraphData}
                                    crossSellingData={top5CrossSellingGraphData}
                                    sizeData={sizeData}
                                    userRoleList={userRoleList}
                                />

                            </Box>
                        </Grid>
                        <Grid item size={{ xs: 12, md: 3 }}>
                            <Box className="chart-container product-details-daily-scan">
                                <div className="area-chart-fill">
                                    <AreaChart
                                        chartData={dailyScanPatternsData}
                                        label="ProductionScan"
                                        fillHeight
                                    />
                                </div>
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {/* Product over product chart */}
                <Box className="product-details-charts">
                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12, md: 12 }}>
                            <Box className="chart-container">
                                <ProductOverProduct type="Product"
                                    productData={productData}
                                    userRoleList={userRoleList}
                                    locationData={locationData}
                                    sizeData={sizeData}
                                    isFilterOpen={activeChartFilter === 'product'}
                                    setIsFilterOpen={(val) => setActiveChartFilter(val ? 'product' : null)}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
                {/* Period over period chart */}
                <Box className="product-details-charts">
                    <Grid container spacing={2}>
                        <Grid item size={{ xs: 12, md: 12 }}>
                            <Box className="chart-container">
                                <PeriodOverPeriod type="Period"
                                    productData={productData}
                                    userRoleList={userRoleList}
                                    locationData={locationData}
                                    sizeData={sizeData}
                                    isFilterOpen={activeChartFilter === 'period'}
                                    setIsFilterOpen={(val) => setActiveChartFilter(val ? 'period' : null)}
                                />
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
        </Box>
    );
};
export default ProductDetails;